// filepath: /src/redux/types/authTypes.js
export const LOGIN_REQUEST   = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS   = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE   = 'auth/LOGIN_FAILURE';
export const LOGOUT_REQUEST  = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS  = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE  = 'LOGOUT_FAILURE';
export const KYC_REQUIRED    = 'KYC_REQUIRED';